/** Inline number field with stepper */
export function InlineNumberField({
  label,
  value,
  onChange,
  min,
  max,
  step,
  suffix,
}: {
  label: string
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
  step?: number
  suffix?: string
}) {
  const increment = step ?? 1

  const clamp = (v: number) => {
    let result = v
    if (min !== undefined) result = Math.max(min, result)
    if (max !== undefined) result = Math.min(max, result)
    return result
  }

  return (
    <div className="flex justify-between items-center gap-2">
      <span className="text-muted-foreground text-xs shrink-0">{label}</span>
      <div className="flex items-center gap-1">
        <button
          type="button"
          className="h-6 w-6 flex items-center justify-center rounded border border-input bg-background text-xs hover:bg-muted transition-colors"
          onClick={() => onChange(clamp(value - increment))}
        >
          -
        </button>
        <input
          type="number"
          className="w-12 h-6 text-center text-xs border border-input rounded bg-background focus:outline-none focus:ring-1 focus:ring-ring [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
          value={value}
          min={min}
          max={max}
          step={step}
          onChange={(e) => {
            const raw = Number(e.target.value)
            if (!Number.isNaN(raw)) onChange(clamp(raw))
          }}
          data-testid={`number-${label.toLowerCase().replace(/\s+/g, '-')}`}
        />
        {suffix && <span className="text-xs text-muted-foreground">{suffix}</span>}
        <button
          type="button"
          className="h-6 w-6 flex items-center justify-center rounded border border-input bg-background text-xs hover:bg-muted transition-colors"
          onClick={() => onChange(clamp(value + increment))}
        >
          +
        </button>
      </div>
    </div>
  )
}
